import { render, staticRenderFns } from "./Create-department.vue?vue&type=template&id=035d19dc&scoped=true"
import script from "./Create-department.vue?vue&type=script&lang=js"
export * from "./Create-department.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d19dc",
  null
  
)

export default component.exports